import dayjs from 'dayjs';

/**
 * 客流计数统计模式枚举
 */
export const PASSENGER_FLOW_MODE_MAP = {
  /** 设备采集 1 */
  DEVICE: 1,
  /** 人工采集 2 */
  OPERATION: 2,
};

/**
 * 客流计数-统计模式
 */
export const PASSENGER_FLOW_MODE = {
  label: '统计模式',
  key: 'passengerFlowMode'
};

/**
 * 客流计数-客流点位(点位id数组)
 */
export const PASSENGER_FLOW_SPOTS = {
  label: '客流点位',
  key: 'passengerFlowSpots'
};

/**
 * 客流计数-周中客流
 */
export const PASSENGER_FLOW_WEEKDAY = {
  label: '周中客流',
  key: 'passengerFlowWeekday'
};

/**
 * 客流计数-周末客流
 */
export const PASSENGER_FLOW_WEEKEND = {
  label: '周末客流',
  key: 'passengerFlowWeekend',
};

/**
 * 客流计数-日均客流
 */
export const PASSENGER_FLOW_AVERAGE = {
  label: '日均客流',
  key: 'passengerFlowAverage',
};

/**
 * 客流计数-点位客流列表（详细信息列表）
 */
export const PASSENGER_FLOW_SPOT_LIST = 'passengerFlowSpotList';

/**
 * 格式化客流计数点位日期展示
 * @param date 日期
 * @returns 2025-08-12(周二)
 */
export const formatPassengerFlowDate = (date: any) => {
  const week = dayjs(date).format('ddd');

  return `${date}(${week})`;
};

/**
 * 客流点位分析状态
 */
export const SPOTS_ANALYSIS_MAP = {
  /** 已分析-3 */
  ANALYSISED: 3
};
